<template>
    <div class="min-h-screen w-full">
        <LoadingScreen />
        <slot />
    </div>
</template>